function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Account Script Template
 *    Scripts to control elements on the account page.
 *
 *  Version:
 *    1.0.0 - 2020/05/26
 */

import $ from 'jquery';
export var ACCOUNT_TEMPLATE_SELECTOR = '[data-account-page]';
export var LOYALTY_POINTS = '[data-loyalty-points]';
var AccountTemplate = /*#__PURE__*/function () {
  function AccountTemplate(container) {
    var _this = this;
    _classCallCheck(this, AccountTemplate);
    this.container = container;
    this.points = container.find(LOYALTY_POINTS);

    //Check to see if LL has initialised
    this.loyaltyLionCheck = setInterval(function () {
      return _this.checkLoyaltyLion();
    }, 100);
  }
  _createClass(AccountTemplate, [{
    key: "checkLoyaltyLion",
    value: function checkLoyaltyLion() {
      // Do we have the required data from Loyalty Lion ready?
      if (!window.loyaltylion.customer) return;
      // clear the interval to stop the function from being called
      clearInterval(this.loyaltyLionCheck);
      this.currentPoints = window.loyaltylion.customer.pointsApproved;
      if (this.points.length) this.points.html(this.currentPoints);
    }
  }]);
  return AccountTemplate;
}(); //Initialize
$(document).ready($(ACCOUNT_TEMPLATE_SELECTOR).each(function (i, e) {
  return new AccountTemplate($(e));
}));